module.exports = __webpack_public_path__ + "static/media/profileImage.2af9f911.jpg";